<template>
    <div>
        <div class="title dark"><Translate translation-key="licenses" /></div>
        <div class="uk-margin-bottom" />

        <div
            class="uk-grid-small uk-grid-match uk-child-width-1-3@l uk-child-width-1-2@s uk-child-width-1-1 uk-flex uk-flex-center"
            uk-grid>
            <div>
                <License
                    :licensed-until="settings.licensedUntil"
                    :description="$t('photoUpload')" />
            </div>
            <div>
                <License
                    :licensed-until="settings.galleryLicensedUntil"
                    :description="$t('gallery')" />
            </div>
            <div>
                <License
                    :licensed-until="settings.terminalLicensedUntil"
                    :description="$t('terminal')" />
            </div>
            <div>
                <License
                    :licensed-until="settings.transferLicensedUntil"
                    :description="$t('transfer')" />
            </div>
            <div>
                <License
                    :licensed-until="settings.clickAndBuyLicensedUntil"
                    :description="$t('clickandbuy')" />
            </div>
        </div>

        <div class="uk-margin-medium-top">
            <a
                :href="generateLicenseUpgrade()"
                target="_blank"
                v-on:click="openLicenseUpgrade()">
                <Button isLarge isMax mode="success">
                    <Icon icon="star" /> {{ $t('license.upgrade') }}
                </Button>
            </a>
        </div>
    </div>
</template>

<script>
import Button from '@/components/generic/Button.vue';
import Icon from '@/components/generic/Icon.vue';
import License from '@/components/License.vue';
import Translate from '@/components/Translate.vue';

export default {
    name: 'AdminLicenses',
    components: {Translate, License, Icon, Button},
    props: {
        settings: Object,
    },
    data() {
        return {
            title: 'licenses',
        };
    },
    computed: {
        computedLicenseLink() {
            if (this.computedClickAndBuyOnly) {
                return 'https://clickandbuy.app/license_upgrade.php?domain=';
            }

            return 'https://phy-prints.com/license_upgrade.php?domain=';
        },
    },
    methods: {
        generateLicenseUpgrade() {
            return this.computedLicenseLink + window.location.origin;
        },

        openLicenseUpgrade() {
            event.stopPropagation();
            event.preventDefault();
            window.open(this.generateQRCode(), '_blank').focus();
        },
        generateQRCode() {
            return this.computedQRCodeLink + window.location.origin;
        },
    },
};
</script>

<style lang="scss" scoped>
.title {
    margin-bottom: 30px;
    text-align: left;
    color: $site-color-hover;
    font-weight: 500;
    font-size: 18px;

    &.dark {
        color: $site-background-hover;
    }
}
</style>
